/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Change_Due_TodayInputs */

const en_plan_change_due_today = /** @type {(inputs: Plan_Change_Due_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due today`)
};

const es_plan_change_due_today = /** @type {(inputs: Plan_Change_Due_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A pagar hoy`)
};

/**
* | output |
* | --- |
* | "Due today" |
*
* @param {Plan_Change_Due_TodayInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_change_due_today = /** @type {((inputs?: Plan_Change_Due_TodayInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Change_Due_TodayInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_change_due_today(inputs)
	return en_plan_change_due_today(inputs)
});